var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroupe1668(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97,
    height: 106,
    viewBox: "0 0 97 106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1668",
    "data-name": "Groupe 1668",
    transform: "translate(-15464 -2168)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1279",
    "data-name": "Rectangle 1279",
    d: "M0,0H97a0,0,0,0,1,0,0V57.5A48.5,48.5,0,0,1,48.5,106h0A48.5,48.5,0,0,1,0,57.5V0A0,0,0,0,1,0,0Z",
    transform: "translate(15464 2168)",
    fill: "#f3f8ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_like-tag",
    "data-name": "vuesax/linear/like-tag",
    transform: "translate(15066 1951)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "like-tag",
    transform: "translate(428 252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(10.792 8.718)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,12.557l2.482,1.927a2.467,2.467,0,0,0,1.526.478H7.061a2.433,2.433,0,0,0,2.251-1.68l1.927-5.843A1.5,1.5,0,0,0,9.713,5.357H6.506A.809.809,0,0,1,5.7,4.4l.4-2.559A1.568,1.568,0,0,0,3.3.64L.015,5.527",
    transform: "translate(4.085 0)",
    fill: "none",
    stroke: "#1b7afa",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,9.373V1.526C0,.4.478,0,1.6,0h.8c1.125,0,1.6.4,1.6,1.526V9.373c0,1.125-.478,1.526-1.6,1.526H1.6C.478,10.9,0,10.5,0,9.373Z",
    transform: "translate(0 3.184)",
    fill: "none",
    stroke: "#1b7afa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M23.125,25.977H21.953a4.606,4.606,0,0,0-3.268,1.341l-2.636,2.606a3.118,3.118,0,0,1-4.363,0L9.05,27.318a4.633,4.633,0,0,0-3.268-1.341H4.625A4.6,4.6,0,0,1,0,21.4V4.579A4.6,4.6,0,0,1,4.625,0h18.5A4.6,4.6,0,0,1,27.75,4.579V21.4A4.609,4.609,0,0,1,23.125,25.977Z",
    transform: "translate(4.625 3.099)",
    fill: "none",
    stroke: "#1b7afa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H37V37H0Z",
    fill: "none",
    opacity: 0
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupe1668);
export default __webpack_public_path__ + "static/media/Groupe-1668.ff3e9ed7700be46362377706ff8122bf.svg";
export { ForwardRef as ReactComponent };